import React from "react";
import {
  Typography,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

export default function HelpPage() {
  return (
    <div>
      <div className="flex items-center gap-2 mb-6">
        <HelpIcon className="text-primary-600 dark:text-primary-400" />
        <Typography variant="h6" className="text-2xl font-bold text-gray-900 dark:text-white">
          Help & Support
        </Typography>
      </div>

      <div className="card-modern p-6">
        <Typography variant="body2" className="text-gray-600 dark:text-gray-400 mb-6">
          Find quick links and resources. More guides coming soon.
        </Typography>

        <div className="space-y-4 mb-6">
          <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
            <a
              href="/pricing"
              className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-semibold text-lg block mb-1"
            >
              Pricing
            </a>
            <Typography variant="body2" className="text-gray-600 dark:text-gray-400">
              See available plans and limits
            </Typography>
          </div>

          <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
            <a
              href="mailto:noreply.reeltale@gmail.com"
              className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-semibold text-lg block mb-1"
            >
              Contact Support
            </a>
            <Typography variant="body2" className="text-gray-600 dark:text-gray-400">
              Email us for help
            </Typography>
          </div>

          <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
            <a
              href={process.env.REACT_APP_GUIDE_URL || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-semibold text-lg block mb-1"
            >
              Instagram Scheduling Guide
            </a>
            <Typography variant="body2" className="text-gray-600 dark:text-gray-400">
              Step-by-step instructions for connecting and scheduling
            </Typography>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-gray-700 pt-6">
          <Typography variant="subtitle1" className="text-lg font-bold text-gray-900 dark:text-white mb-4">
            FAQs
          </Typography>
          <div className="space-y-4">
            <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
              <Typography variant="subtitle2" className="text-gray-900 dark:text-white font-semibold mb-2">
                Why don't I see my Pages after login?
              </Typography>
              <Typography variant="body2" className="text-gray-600 dark:text-gray-400">
                Ensure the Facebook permissions were granted and that your account has access to the Page. Try reconnecting from Settings.
              </Typography>
            </div>

            <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
              <Typography variant="subtitle2" className="text-gray-900 dark:text-white font-semibold mb-2">
                Why are some features unavailable right now?
              </Typography>
              <Typography variant="body2" className="text-gray-600 dark:text-gray-400">
                If the Facebook API is rate-limited temporarily, features may be unavailable. Please retry in a few minutes.
              </Typography>
            </div>

            <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl">
              <Typography variant="subtitle2" className="text-gray-900 dark:text-white font-semibold mb-2">
                How do I switch themes?
              </Typography>
              <Typography variant="body2" className="text-gray-600 dark:text-gray-400">
                Use the sun/moon icon in the top bar to toggle light and dark modes.
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
